import Vue from 'vue'
import {
	Tabbar,
	TabbarItem,
	Swipe,
	SwipeItem,
	Icon,
	Tab,
	Tabs

} from 'vant'
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
